import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {
    DocumentRequirementModel, GetDocumentRequirementResponse, GetSubscribedDocumentRequirementResponse,
    GetDocumentsAndFormsResponse, SaveDocumentVesselSubscriptionRequest, GetDocumentRequirementVesselsResponse,
    GetVesselDocumentRequirementsCount, DocumentEntityModel, GetUnreadDocumentInquiriesResponse,
    GetSubscribedRequirementsOverviewResponse, GetDocumentsResponse, GetDocumentsForEntitiesByDocumentRequirementIdRequest,
    CountHybridDocumentRequest
} from "../models/document-management.models";

@autoinject
export class DocumentRequirementApi {

    public documentRequirementApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentRequirement`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //Get document requirement
    public getDocumentRequirement(id: number): Promise<DocumentRequirementModel> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetDocumentRequirement/${id}`, {});
    }

    //Get my document requirement
    public getMyDocumentRequirement(id: number): Promise<DocumentRequirementModel> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetMyDocumentRequirement/${id}`, {});
    }

    //Get documents and forms for vessel
    public getDocumentsAndFormsForVessel(entityTypeId: number, entityId: number): Promise<GetDocumentsAndFormsResponse> {
        return this.requestClientService.get<GetDocumentsAndFormsResponse>(`${this.documentRequirementApi}/GetDocumentsAndFormsForVessel/${entityTypeId}/${entityId}`, {});
    }

    //Get documents and forms for vessel
    public getDocumentsForEntitiesByDocumentRequirementId(request: GetDocumentsForEntitiesByDocumentRequirementIdRequest): Promise<GetDocumentsResponse> {
        return this.requestClientService.post<GetDocumentsAndFormsResponse>(`${this.documentRequirementApi}/GetDocumentsForEntitiesByDocumentRequirementId`, {}, request);
    }

    //Get documents for company (DOC)
    public getDocumentsForCompanyByDocumentRequirementId(companyId: number, documentRequirementId: number): Promise<GetDocumentsResponse> {
        return this.requestClientService.get<GetDocumentsAndFormsResponse>(`${this.documentRequirementApi}/GetDocumentsForCompanyByDocumentRequirementId/${companyId}/${documentRequirementId}`, {});
    }

    //Delete document requirement
    public deleteDocumentRequirement(id: number): Promise<boolean> {
        return this.requestClientService.post(`${this.documentRequirementApi}/DeleteDocumentRequirement/${id}`, {});
    }

    //Save document requirement
    public saveDocumentRequirement(request: DocumentRequirementModel): Promise<any> {
        return this.requestClientService.post(`${this.documentRequirementApi}/SaveDocumentRequirement`, {}, request);
    }

    //Save document vessel subscription
    public saveDocumentVesselSubscription(request: SaveDocumentVesselSubscriptionRequest): Promise<any> {
        return this.requestClientService.post(`${this.documentRequirementApi}/SaveDocumentVesselSubscription`, {}, request);
    }

    //Get my document requirement
    public getMyDocumentRequirements(): Promise<GetDocumentRequirementResponse[]> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetMyDocumentRequirements`, {});
    }

    //Get document requirements by Customer Id
    public getDocumentRequirementsByCustomerId(customerId: number): Promise<GetDocumentRequirementResponse[]> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetDocumentRequirementsByCustomerId?customerId=${customerId}`, {});
    }

    //Get document requirement
    public getAvailableDocumentRequirement(vesselTypeGroupIds: number[], includeTypeGroup = false): Promise<GetDocumentRequirementResponse[]> {
        return this.requestClientService.post(`${this.documentRequirementApi}/GetAvailableDocumentRequirements`, {}, { vesselTypeGroupIds: vesselTypeGroupIds, includeTypeGroup: includeTypeGroup });
    }

    //Get subscribed document requirement
    public getSubscribedDocumentRequirement(): Promise<GetSubscribedDocumentRequirementResponse[]> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetSubscribedDocumentRequirements`, {});
    }

    //Get subscribed document requirement count
    public getSubscribedDocumentCount(): Promise<number> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetSubscribedDocumentCount`, {});
    }

    //Get subscribed document requirement count
    public getDocumentRequirementIdByName(name: string): Promise<number> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetDocumentRequirementIdByName`, { name: name });
    }

    //Get document requirement vessels
    public getDocumentRequirementVessels(documentRequirementId: number): Promise<GetDocumentRequirementVesselsResponse> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetDocumentRequirementVessels?documentRequirementId=${documentRequirementId}`, {});
    }

    //Get documents and forms for vessel
    public getVesselDocumentsCount(vesselId: number): Promise<number> {
        return this.requestClientService.get<number>(`${this.documentRequirementApi}/GetVesselDocumentsCount/${vesselId}`, {});
    }

    //Get documents for company (DOC)
    public getCompanyDocumentsCount(companyId: number): Promise<number> {
        return this.requestClientService.get<number>(`${this.documentRequirementApi}/GetCompanyDocumentsCount/${companyId}`, {});
    }

    public getCustomerVesselDocumentsCount(vesselId: number): Promise<GetVesselDocumentRequirementsCount> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetCustomerVesselDocumentsCount/${vesselId}`, {});
    }

    public getCustomerSubscribedVesselDocumentsCount(vesselId: number): Promise<GetVesselDocumentRequirementsCount> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetCustomerSubscribedVesselDocumentsCount/${vesselId}`, {});
    }

    public getUnreadDocumentInquiries(entityTypeId: number, entityId: number, documents: DocumentEntityModel[]): Promise<GetUnreadDocumentInquiriesResponse> {
        return this.requestClientService.post(`${this.documentRequirementApi}/GetUnreadDocumentInquiries`, {}, { entityTypeId: entityTypeId, entityId: entityId, documents: documents });
    }

    //Get subscribed document requirement
    public getSubscribedRequirementsOverview(isRequestingParty: boolean = false): Promise<GetSubscribedRequirementsOverviewResponse> {
        return this.requestClientService.get(`${this.documentRequirementApi}/GetSubscribedRequirementsOverview`, { isRequestingParty: isRequestingParty });
    }

    public countHybridDocument(request: CountHybridDocumentRequest): Promise<number> {
        return this.requestClientService.post(`${this.documentRequirementApi}/CountHybridDocument`, {}, request);
    }
}
